import { useAdParams } from '../../../hooks/useAdParams';

const BOOKING_URL = 'https://nekonosenaka.hot-yoyaku.net/e_repeat/cbe/users?u=s3hm7veyo0&k=mirror&s=c-c-r/15';

export default function Hero() {
  const { appendParams } = useAdParams();
  const bookingUrl = appendParams(BOOKING_URL);

  return (
    <section className="relative bg-gradient-to-br from-yellow-50 via-orange-50 to-yellow-50 overflow-hidden">
      <div className="relative w-full">
        <header className="flex items-center justify-between bg-orange-500 px-4 py-3">
          <div className="flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/b232d040de61573eedf12b26b009967a.png"
              alt="ねこのせなか整体院"
              className="h-8 w-auto"
            />
            <div>
              <h1 className="text-sm font-bold text-white leading-tight">ねこのせなか整体院</h1>
            </div>
          </div>
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 bg-white text-orange-500 px-3 py-1.5 rounded-full text-xs hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-sm"></i>
            <span className="font-semibold">予約する</span>
          </a>
        </header>

        <div>
          <img
            src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/f85f2e75a59468ac98678494080ba9af.png"
            alt="産後骨盤矯正でキレイになる"
            className="w-full h-auto block"
          />
        </div>

        <div className="px-4 py-4">
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#F88379] text-white px-6 py-3.5 rounded-full text-base font-semibold hover:bg-[#e6706a] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            <span>今すぐ予約する</span>
          </a>
        </div>
      </div>
    </section>
  );
}
